/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import React, { useEffect, useState } from "react";

// @mui material components
import Icon from "@mui/material/Icon";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Tooltip, { TooltipProps, tooltipClasses } from "@mui/material/Tooltip";
import Button from "@mui/material/Button";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { styled } from "@mui/system";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

// Settings page components
import DashboardLayout from "LayoutContainers/DashboardLayout";
import DashboardNavbar from "components/Skill90DashboardNavbar";
import DataTable from "Tables/DataTable";
import AdvancedSettlementFilters from "./components/Filters";
import SoftSelect from "components/SoftSelect";
// react-select components

// import BasicInfo from "./components/BasicInfo";
// import ChangePassword from "./components/ChangePassword";
// import DeleteAccount from "./components/DeleteAccount";

// react-router components
import { useLocation, useSearchParams } from "react-router-dom";

import { getData, postData } from "Utils/server";
import { getAuthorizationHeader, getUserData } from "Utils/helpers";
import { useSoftUIController } from "context";

// sweetalert2 components
import Swal from "sweetalert2";

import DialogBox from "Modals/CheckLeavePage";
import { useCallbackPrompt } from "hooks/useCallbackPrompt";

import csvDownload from "json-to-csv-export";
import SoftInput from "components/SoftInput";
import { Menu, TextField } from "@mui/material";
import NotificationItem from "components/Skill90NotificationItem";
import DownloadJSON from "components/DownloadJSON";
import SoftProgress from "components/SoftProgress";

/**
 *
 */
const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    //backgroundColor: "#f5f5f9",
    backgroundColor: "#000",
    color: "rgba(f, f, f, 1)", //"rgba(0, 0, 0, 0.87)",
    placement: "left",
    maxWidth: 600,
    minWidth: "minContent",
    height: "minContent",
    textAlign: "left",
    fontSize: "0.65erm",
    border: "1px solid #dadde9",
    boxShadow: "0rem 1.25rem 1.6875rem 0rem rgba(0, 0, 0, 0.05)",
    padding: "15px",
    marginLeft: "15px",
  },
}));

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="outlined" {...props} />;
});

let settlementOutcomes = [];
let settlements = [];
let originalData = [];
let currentData = [];
let availableProviders = [];
let blockedIds = {};

function AdvancedSettlement() {
  const userData = getUserData();
  const [controller, dispatch] = useSoftUIController();

  const { providers } = controller;

  const [updateEnabled, setUpdateEnabled] = useState(false);
  const [filterToggle, setFilterToggle] = useState(true);
  const [loadingData, setLoadingData] = useState(false);
  const [applyFilters, setApplyFilters] = useState(false);
  const [displayData, setDisplayData] = useState(false);
  const [preloadFilters, setPreloadFilters] = useState(null);

  const [notification, setNotification] = useState(false);
  const [apiResponse, setApiresponse] = useState("success");
  const [apiResponseMsg, setApiResponseMsg] = useState("success");
  const [modeChanges, setModeChanges] = useState(false);

  const [showDialog, setShowDialog] = useState(false);
  const [showPrompt, confirmNavigation, cancelNavigation] = useCallbackPrompt(showDialog);
  const [externalSearch, setExternalSearch] = useState(null);
  const [loading, setLoading] = useState(false);

  const [openTimeline, setOpenTimeline] = useState(false);
  const [openScoreboard, setOpenScoreboard] = useState(false);
  const [selectedTimeline, setSelectedTimeline] = useState(null);
  const [selectedScoreboard, setSelectedScoreboard] = useState(null);
  const [timelineEvent, setTimelineEvent] = useState(null);

  const spSportsAvailable = ["greyhounds", "trotting", "horseracing"];

  const [blockedFixturesDict, setBlockedFixturesDict] = useState({});

  const abortController = new AbortController();

  //const [availableProviders, setAvailableProviders] = useState([]);

  const [settlementOrigins, setSettlementOrigins] = useState([
    { value: 1, label: "Live Settlement" },
    { value: 3, label: "Operator" },
    { value: 2, label: "Statistics Settlement" },
  ]);

  const [dataTableData, setDataTableData] = useState({
    columns: [
      { Header: "tm", accessor: "tm", width: "100px" },
      // { Header: "Market", accessor: "uni_name", width: "100px", Cell: merge_uniname_numbers },
      { Header: "Market Name", accessor: "name", width: "100px", Cell: renderMarketName },
      { Header: "Odd Name", accessor: "odd_name", width: "100px" },
      { Header: "Odd e", accessor: "e", width: "100px", Cell: renderProperties },
      { Header: "Odd h", accessor: "h", width: "100px", Cell: renderProperties },
      { Header: "Odd o", accessor: "o", width: "100px", Cell: renderProperties },
      { Header: "SP", accessor: "sp", width: "80px", Cell: renderSP },
      { Header: "Payment%", accessor: "payment_percentage", width: "80px", Cell: renderPayment },
      { Header: "Outcome", accessor: "outcome_id", width: "80px", Cell: possibleSettlement },
      // { Header: "Settler", accessor: "origin_id", width: "100px", Cell: formatOrigin },
      // { Header: "Status", accessor: "f_status", width: "100px", Cell: formatStatus },

      { Header: "Sport", accessor: "sport", width: "80px" },
      //{ Header: "Provider", accessor: "provider_name", width: "110px", Cell: formatProvider },

      // { Header: "Providers", accessor: "provider_names", width: "110px" },
      { Header: "Region", accessor: "region", width: "100px" },
      { Header: "Competition", accessor: "competition", width: "100px", Cell: formatCompetition },

      { Header: "Home", accessor: "home", width: "120px" },
      { Header: "Away", accessor: "away", width: "120px", Cell: showFixtureData },
      { Header: "Start Date", accessor: "start_date_utc", width: "100px", Cell: formatDate },
      // { Header: "Platform", accessor: "platform_name", width: "100px" },
      { Header: "Status", accessor: "statuses", width: "100px", Cell: formatStatuses },
      { Header: "Providers", accessor: "providers", width: "110px", Cell: formatProvider },
      {
        Header: "fixture Ids",
        accessor: "fixtureIds",
        width: "100px",
        Cell: goToScoreboardByEventId,
      },
      { Header: "Uni ID", accessor: "uni_id", width: "100px", Cell: goToScoreboardByUniId },

      //{ Header: "Bet Id", accessor: "bet_id", width: "100px" },
      { Header: "UUID", accessor: "uuid", width: "100px", Cell: formatUuid },
      { Header: "Platform", accessor: "platforms", width: "100px", Cell: joinArrays },
      { Header: "Bet Ids", accessor: "betIds", width: "100px", Cell: joinBets },
      {
        Header: "Betbuilder Ids",
        accessor: (row) =>
          row.betbuilderIds ??
          row.betbuilder_ids ??
          row.betbuilder_id ??
          row.betBuilderIds ??
          row.betBuilderId ??
          row.betbuilderId,
        id: "betbuilderIds",
        width: "100px",
        Cell: joinBetbuilderIds,
      },
      {
        Header: "Bet Outcomes",
        accessor: "betOutcomes",
        width: "100px",
        Cell: possibleSettlements,
      },
      { Header: "updated", accessor: "updated", width: "100px" },
      //{ Header: "fixture Id", accessor: "event_id", width: "100px" },

      {
        Header: "Bet Date",
        accessor: "betDates",
        width: "100px",
        Cell: formatMultiUTC,
      },
      {
        Header: "Settlement Date",
        accessor: "settlement_date",
        width: "100px",
        Cell: formatDateStringUTCtoLocaleCell,
      },
      {
        Header: "Time Settlement Diff",
        accessor: "diff",
        width: "100px",
        Cell: formatSettlementDateDiff,
      },
      {
        Header: "Settled by",
        accessor: "settler",
        width: "100px",
        Cell: formatSettler,
      },
      {
        Header: "Ask Confirmation Date",
        accessor: "ask_confirmation_at",
        width: "100px",
        Cell: formatDateStringUTCtoLocaleCell,
      },
      {
        Header: "Settlement-Confirmation Diff",
        accessor: "conf_diff",
        width: "100px",
        Cell: formatSettlementDateDiff,
      },
      {
        Header: "Confirmed by",
        accessor: "confirmator_username",
        width: "100px",
        Cell: formatConfirmator,
      },
      {
        Header: "Results",
        accessor: "id",
        Cell: formatSearchEngines,
      },
      {
        Header: "Notes",
        accessor: "note",
        Cell: editNotes,
      },
    ],

    rows: [],
  });
  const [hiddenColumns, setHiddenColumns] = useState(["tm"]);
  let [searchParams, setSearchParams] = useSearchParams();

  const { hash, pathname, search } = useLocation();

  const platforms = userData
    ? userData.platforms
      ? userData.platforms.map((platform) => ({
          value: platform.id,
          label: platform.name,
          logo: platform.logo,
          sorting: platform.sorting,
          odds_styles: platform.odds_styles,
        }))
      : []
    : [];

  function openInNewWindow(e, uri) {
    e.preventDefault();
    let url = uri;
    // console.log(window.URL);
    window.open(url.toString(), "_blank", "noreferrer");
  }

  async function fetchBetsOdds(filters, reset) {
    if (!reset) setDisplayData(false);
    let filtersToSend = { ...filters };
    if (!reset) setFilterToggle(true);
    setLoadingData(true);
    setLoading(true);

    filtersToSend = createfiltersData(filtersToSend);

    blockedIds = await fetchBlockedFixtures();

    if (!filtersToSend || JSON.stringify(filtersToSend) == "{}") return;

    let getOddsEndpoint = `/api/v1/bets/settlements`;
    let response = await postData(getOddsEndpoint, filtersToSend, {
      Authorization: getAuthorizationHeader(),
    });
    if (response != null) {
      //console.log(response.data);

      if (response.data.length == 0) {
        setApiresponse("error");
        setApiResponseMsg("There are NO Data for the selected filters.");
        setNotification(true);
        setLoadingData(false);
        setLoading(false);
        return;
      }

      let dataTable = { ...dataTableData };
      setDataTableData({ columns: [], rows: [] });
      await sleep(1000);
      dataTable.rows = response.data;

      for (let index = 0; index < response.data.length; index++) {
        const row = response.data[index];
        let settlement_date = new Date(row.settlement_date);
        let finished_at_date = row.finished_at_utc ? new Date(row.finished_at_utc * 1) : 0;

        let autoSettlement =
          finished_at_date == 0
            ? row.settlement_date
              ? "online"
              : null
            : settlement_date > finished_at_date
            ? "offline"
            : "online";

        let ask_confirmation_at = row.ask_confirmation_at
          ? new Date(row.ask_confirmation_at)
          : null;

        row.settler = row.settled_by_operator
          ? row.username
            ? "operator: " + row.username
            : "operator"
          : row.settlement_date
          ? "system: " + autoSettlement
          : null;

        let start_date_at = new Date(row.start_date_utc * 1);
        let diffTime = null;

        diffTime =
          autoSettlement == "offline"
            ? Math.abs(settlement_date.getTime() - finished_at_date.getTime())
            : Math.abs(settlement_date.getTime() - start_date_at.getTime());

        row.diff = diffTime;

        row.conf_diff = ask_confirmation_at
          ? Math.abs(settlement_date.getTime() - ask_confirmation_at.getTime())
          : null;
        row.tm = new Date().getTime();
        row.sortDate = settlement_date.getTime();
        row.payment_percentage = "";

        row.provider_name = row.providers
          .map((item, index) => {
            let provider = availableProviders.find((p) => p.value === item);
            let providerName = provider ? provider["info"] : item;
            return providerName;
          })
          .join(",");

        // row.blocked = [];

        // row.fixture_id.map((f, index) => {
        //   if (blockedIds[`${row.providers[index]}:${f}`]) row.blocked.push(f);
        // });

        // row.blocked = blockedIds[`${row.providerId}:${row.fixture_id}`]
        //   ? blockedIds[`${row.providerId}:${row.fixture_id}`]
        //   : false;
      }

      dataTable.rows.sort((a, b) => b.sortDate - a.sortDate);

      currentData = { ...dataTable };
      originalData = { ...dataTable };

      setHiddenColumns(["tm", "updated", "provider_names"]);
      setDataTableData(dataTable);
      if (dataTable.rows.length > 0 && !reset) setFilterToggle(false);
      if (!reset) setDisplayData(true);
      setLoadingData(false);
      setLoading(false);
    } else {
    }
  }

  async function fetchSettlementValues() {
    let settlementOutcomesEndPoint = `/api/v1/entities/availableSettlementOutcomes`;
    let response = await getData(settlementOutcomesEndPoint, {
      Authorization: getAuthorizationHeader(),
    });
    if (response != null) {
      //console.log(response.data);
      const noneOption = [{ value: 0, label: "Select..." }];
      const apiOptions = response.data.map((item) => {
        return { value: item.id, label: item.description };
      });

      const allOptions = noneOption.concat(apiOptions);

      settlementOutcomes = allOptions.map((item) => {
        return { value: item.value, label: item.label };
      });
    }
  }

  async function getVotes(e, uuid) {
    e.preventDefault();
    setLoading(true);
    let getOddVotesEndPoint = `/api/v1/settlements/votes`;
    let response = await postData(
      getOddVotesEndPoint,
      { uuid: uuid },
      {
        Authorization: getAuthorizationHeader(),
      }
    );
    if (response != null) {
      let dataTable = { ...dataTableData };

      // await setDataTableData({ columns: [], rows: [] });
      dataTable.rows = currentData.rows;

      for (let index = 0; index < dataTable.rows.length; index++) {
        const odd = dataTable.rows[index];
        if (odd.uuid === uuid) {
          odd.tm = new Date().getTime();
          odd.votes = response.data[uuid]?.sort((a, b) => b.timestamp - a.timestamp);
          break;
        }
      }
      setDataTableData(dataTable);
      await sleep(10);
      setDataTableData(dataTable);
      await sleep(10);
      currentData.rows = dataTable.rows;

      setLoading(false);
    }
  }

  async function fetchBlockedFixtures() {
    let getBlockedFixturesEndpoint = `/api/v2/panel/filters/fixtures/blocked`;
    let response = await getData(
      getBlockedFixturesEndpoint,
      { Authorization: getAuthorizationHeader() },
      null,
      abortController ? { signal: abortController.signal } : null
    );

    const blockedIdsDictionary = {};
    if (response != null) {
      for (let index = 0; index < response.data.length; index++) {
        const blockedFixture = response.data[index];
        blockedIdsDictionary[`${blockedFixture.provider_id}:${blockedFixture.fixture_id}`] =
          blockedFixture.status == "blocked";
      }
    }

    setBlockedFixturesDict(blockedIdsDictionary);
    return blockedIdsDictionary;
  }

  function renderMarketName({ value, ...rest }) {
    let listItems = rest.row.original.votes;
    return (
      <div className="cell-width">
        <HtmlTooltip
          placement="right"
          title={
            <React.Fragment>
              <div style={{ display: "flex", flexWrap: "wrap" }}>{rest.row.original.uni_name}</div>
            </React.Fragment>
          }
        >
          <div>
            <div>{value}</div>
            <Icon
              style={{
                display: rest.row.original.fast_market ? "" : "none",
                color: "forestgreen",
              }}
            >
              bolt_outlined_icon
            </Icon>
            <Icon
              style={{
                display: rest.row.original.players_market ? "" : "none",
                color: "forestgreen",
              }}
            >
              directions_run_outlined_icon
            </Icon>
          </div>
        </HtmlTooltip>
        <HtmlTooltip
          placement="right"
          title={
            <React.Fragment>
              {!listItems || listItems.length == 0
                ? "No Votes Exist."
                : listItems?.map((item, index) => {
                    let provider = availableProviders.find((p) => p.value === item.providerId);
                    let providerName = provider ? provider["info"] : item.providerId;
                    let voteDate = new Date(item.timestamp);
                    return (
                      <div
                        key={index}
                        style={{
                          opacity: item.discarded ? "60%" : "100",
                          color: item.discarded ? "red" : "",
                          width: "max-content",
                          display: "inline-flex",
                        }}
                      >
                        <div className={"provider-" + providerName + "-inverse provider-inverse"}>
                          {providerName}
                        </div>
                        <div>
                          {": "}
                          <span style={{ display: "inline-block", minWidth: "100px" }}>
                            {settlementOutcomes.find((s) => s.value == item.outcomeId).label}
                          </span>
                          {item.originId == 1 ? (
                            <span
                              style={{
                                color: "#66d432",
                                display: "inline-block",
                                minWidth: "150px",
                              }}
                            >
                              Online Settlement
                            </span>
                          ) : item.originId == 2 ? (
                            <span
                              style={{
                                color: "#d432bb",
                                display: "inline-block",
                                minWidth: "150px",
                              }}
                            >
                              Offline Settlement
                            </span>
                          ) : item.originId == 4 ? (
                            <span
                              style={{
                                color: "#f9d900",
                                display: "inline-block",
                                minWidth: "150px",
                              }}
                            >
                              FastTrack
                            </span>
                          ) : (
                            <span
                              style={{
                                color: "#3acaeb",
                                display: "inline-block",
                                minWidth: "150px",
                              }}
                            >
                              Operator
                            </span>
                          )}{" "}
                          ({formatDateStringUTCtoLocale(item.timestamp)})
                        </div>
                      </div>
                    );
                  })}
            </React.Fragment>
          }
        >
          <Button
            style={{
              padding: 0,
              padding: "0px",
              width: "30px",
              maxWidth: "30px",
              minWidth: "10px",
              color: rest.row.original.votes ? "" : "red",
            }}
            onClick={(e) => getVotes(e, rest.row.original.uuid)}
          >
            <span style={{ paddingLeft: "5px" }}> </span>
            <Icon>how_to_vote_icon </Icon>
          </Button>
        </HtmlTooltip>
      </div>
    );
  }

  function renderProperties({ value, ...rest }) {
    return (
      <div style={{ color: value == "over" ? "green" : value == "under" ? "red" : "" }}>
        {value}
      </div>
    );
  }

  function renderSP({ value, ...rest }) {
    let isRacingSport = spSportsAvailable.includes(
      rest.row.original.sport.toLowerCase().replace(/ /g, "")
    );
    return (
      isRacingSport && (
        <div style={{ display: "flex" }} key={rest.row.original.uuid + "-" + rest.row.original.tm}>
          <SoftInput
            className="sp-value"
            placeholder="SP..."
            defaultValue={rest.row.original.sp}
            onChange={(e) => setSP(e, rest.row)}
          />
          <Button onClick={(e) => getSP(e, rest.row)}>
            <Icon
              style={{
                color: "#87cb16",
                marginTop: "auto",
                marginBottom: "auto",
                marginLeft: "10px",
              }}
            >
              download_for_offline_icon
            </Icon>
          </Button>
        </div>
      )
    );
  }

  function renderPayment({ value, ...rest }) {
    return (
      <div
        style={{ display: "flex" }}
        key={rest.row.original.uuid + "-payment-" + rest.row.original.tm}
      >
        <SoftInput
          className="sp-value"
          placeholder="1%"
          defaultValue={rest.row.original.payment_percentage}
          onChange={(e) => setPayment(e, rest.row)}
        />
        <Button onClick={(e) => getPayment(e, rest.row)}>
          <Icon
            style={{
              color: "#87cb16",
              marginTop: "auto",
              marginBottom: "auto",
              marginLeft: "10px",
            }}
          >
            download_for_offline_icon
          </Icon>
        </Button>
      </div>
    );
  }

  async function getSP(e, row) {
    e.preventDefault();
    setLoading(true);
    let getOddSpEndPoint = `/api/v1/bets/odd/sp`;
    let uuid = row.original.uuid;
    let response = await postData(
      getOddSpEndPoint,
      { uuid: uuid, confirmed: row.original.status === "Settled" ? true : false },
      {
        Authorization: getAuthorizationHeader(),
      }
    );
    if (response != null) {
      let dataTable = { ...dataTableData };

      // await setDataTableData({ columns: [], rows: [] });
      dataTable.rows = currentData.rows;

      for (let index = 0; index < dataTable.rows.length; index++) {
        const odd = dataTable.rows[index];
        if (odd.uuid === uuid) {
          odd.tm = new Date().getTime();
          odd.sp = response.data.sp;
          odd.sp_history = response.data.sps;
          break;
        }
      }
      setDataTableData(dataTable);
      await sleep(10);
      setDataTableData(dataTable);
      await sleep(10);
      currentData.rows = dataTable.rows;

      setLoading(false);
    }
  }

  function setSP(e, row) {
    e.preventDefault();
    // console.log(e.currentTarget.value);
    // console.log(spData);
    // setUpdateEnabled(false);
    row.original.sp = e.currentTarget.value;
    const settlement = {
      uuid: row.original.uuid,
      outcome_id: row.original.outcome_id,
      event_id: row.original.uni_id ? row.original.uni_id : row.original.event_id,
      provider_id: row.original.provider_id,
      sp: e.currentTarget.value,
      payment_percentage: row.original.payment_percentage,
    };
    const settlementExist = settlements.find((item) => item.uuid === settlement.uuid);
    if (!settlementExist) {
      if (settlement.outcome_id === 0) return;
      settlements.push(settlement);
    } else {
      if (settlement.outcome_id === 0) {
        let settlementExistIndex = settlements.findIndex(
          (item) => item.uuid === settlementExist.uuid
        );
        settlements.splice(settlementExistIndex, 1);
      } else {
        settlementExist.sp = settlement.sp;
      }
    }
    // if (settlements.length > 0) setUpdateEnabled(true);
  }

  async function getPayment(e, row) {
    e.preventDefault();
    setLoading(true);
    let getOddSpEndPoint = `/api/v1/bets/odd/payment`;
    let uuid = row.original.uuid;
    let response = await postData(
      getOddSpEndPoint,
      { uuid: uuid, confirmed: row.original.confirmed },
      {
        Authorization: getAuthorizationHeader(),
      }
    );
    if (response != null) {
      let dataTable = { ...dataTableData };

      // await setDataTableData({ columns: [], rows: [] });
      dataTable.rows = currentData.rows;

      for (let index = 0; index < dataTable.rows.length; index++) {
        const odd = dataTable.rows[index];
        if (odd.uuid === uuid) {
          odd.tm = new Date().getTime();
          odd.payment_percentage = response.data.payment;
          odd.payment_history = response.data.payments;
          break;
        }
      }
      setDataTableData(dataTable);
      await sleep(10);
      setDataTableData(dataTable);
      await sleep(10);
      currentData.rows = dataTable.rows;

      setLoading(false);
    }
  }

  function setPayment(e, row) {
    e.preventDefault();
    // console.log(e.currentTarget.value);
    // console.log(spData);
    setUpdateEnabled(false);
    const settlement = {
      uuid: row.original.uuid,
      outcome_id: row.original.outcome_id,
      event_id: row.original.uni_id ? row.original.uni_id : row.original.event_id,
      provider_id: row.original.provider_id,
      sp: row.original.sp,
      payment_percentage: e.currentTarget.value,
    };
    const settlementExist = settlements.find((item) => item.uuid === settlement.uuid);
    if (!settlementExist) {
      if (settlement.outcome_id === 0) return;
      settlements.push(settlement);
    } else {
      if (settlement.outcome_id === 0) {
        let settlementExistIndex = settlements.findIndex(
          (item) => item.uuid === settlementExist.uuid
        );
        settlements.splice(settlementExistIndex, 1);
      } else {
        settlementExist.payment_percentage = settlement.payment_percentage;
      }
    }
    if (settlements.length > 0) setUpdateEnabled(true);
  }

  function createfiltersData(filtersToSend) {
    if (
      (filtersToSend["fixture_date_filter"] || filtersToSend["fixture_date_filter"] == 0) &&
      filtersToSend["fixture_date_filter"] != 100
    ) {
      if (filtersToSend["fixture_date_filter"] != -100) {
        let today = new Date();
        today.setHours(0, 0, 0, 0);
        let day = new Date(today);
        day.setHours(0, 0, 0, 0);
        day.setDate(today.getDate() + filtersToSend["fixture_date_filter"]);
        let dt_from = filtersToSend["fixture_date_filter"] >= 0 ? today : day;
        let dt_to = filtersToSend["fixture_date_filter"] >= 0 ? day : today;
        filtersToSend["fixture_from_date"] = new Date(dt_from).toUTCString();
        filtersToSend["fixture_to_date"] = new Date(dt_to).toUTCString();
      } else {
        filtersToSend["fixture_from_date"] = null;
        filtersToSend["fixture_to_date"] = null;
      }
    } else {
      if (filtersToSend["fixture_date_filter"] == 100) {
        if (filtersToSend["fixture_from_date"]) {
          let dt =
            filtersToSend["fixture_from_date"].getUTCFullYear() +
            "-" +
            (filtersToSend["fixture_from_date"].getMonth() + 1 < 10
              ? "0" + (filtersToSend["fixture_from_date"].getMonth() + 1)
              : filtersToSend["fixture_from_date"].getMonth() + 1) +
            "-" +
            (filtersToSend["fixture_from_date"].getDate() < 10
              ? "0" + filtersToSend["fixture_from_date"].getDate()
              : filtersToSend["fixture_from_date"].getDate()) +
            "T00:00:00Z";
          filtersToSend["fixture_from_date"] = new Date(dt).toUTCString();
        }
        if (filtersToSend["fixture_to_date"]) {
          let dt =
            filtersToSend["fixture_to_date"].getUTCFullYear() +
            "-" +
            (filtersToSend["fixture_to_date"].getMonth() + 1 < 10
              ? "0" + (filtersToSend["fixture_to_date"].getMonth() + 1)
              : filtersToSend["fixture_to_date"].getMonth() + 1) +
            "-" +
            (filtersToSend["fixture_to_date"].getDate() < 10
              ? "0" + filtersToSend["fixture_to_date"].getDate()
              : filtersToSend["fixture_to_date"].getDate()) +
            "T00:00:00Z";
          filtersToSend["fixture_to_date"] = new Date(dt).toUTCString();
        }
      }
    }

    if (
      (filtersToSend["bet_date_filter"] || filtersToSend["bet_date_filter"] == 0) &&
      filtersToSend["bet_date_filter"] != 100
    ) {
      if (filtersToSend["bet_date_filter"] != -100) {
        let today = new Date();
        today.setHours(0, 0, 0, 0);
        let day = new Date(today);
        day.setHours(0, 0, 0, 0);
        day.setDate(today.getDate() + filtersToSend["bet_date_filter"]);
        let dt_from = filtersToSend["bet_date_filter"] >= 0 ? today : day;
        let dt_to = filtersToSend["bet_date_filter"] >= 0 ? day : today;
        filtersToSend["bet_from_date"] = new Date(dt_from).toUTCString();
        filtersToSend["bet_to_date"] = new Date(dt_to).toUTCString();
      } else {
        filtersToSend["bet_from_date"] = null;
        filtersToSend["bet_to_date"] = null;
      }
    } else {
      if (filtersToSend["bet_date_filter"] == 100) {
        if (filtersToSend["bet_from_date"]) {
          let dt =
            filtersToSend["bet_from_date"].getUTCFullYear() +
            "-" +
            (filtersToSend["bet_from_date"].getMonth() + 1 < 10
              ? "0" + (filtersToSend["bet_from_date"].getMonth() + 1)
              : filtersToSend["bet_from_date"].getMonth() + 1) +
            "-" +
            (filtersToSend["bet_from_date"].getDate() < 10
              ? "0" + filtersToSend["bet_from_date"].getDate()
              : filtersToSend["bet_from_date"].getDate()) +
            "T00:00:00Z";
          filtersToSend["bet_from_date"] = new Date(dt).toUTCString();
        }
        if (filtersToSend["bet_to_date"]) {
          let dt =
            filtersToSend["bet_to_date"].getUTCFullYear() +
            "-" +
            (filtersToSend["bet_to_date"].getMonth() + 1 < 10
              ? "0" + (filtersToSend["bet_to_date"].getMonth() + 1)
              : filtersToSend["bet_to_date"].getMonth() + 1) +
            "-" +
            (filtersToSend["bet_to_date"].getDate() < 10
              ? "0" + filtersToSend["bet_to_date"].getDate()
              : filtersToSend["bet_to_date"].getDate()) +
            "T00:00:00Z";
          filtersToSend["bet_to_date"] = new Date(dt).toUTCString();
        }
      }
    }

    if (
      (filtersToSend["betbuilder_date_filter"] || filtersToSend["betbuilder_date_filter"] == 0) &&
      filtersToSend["betbuilder_date_filter"] != 100
    ) {
      if (filtersToSend["betbuilder_date_filter"] != -100) {
        let today = new Date();
        today.setHours(0, 0, 0, 0);
        let day = new Date(today);
        day.setHours(0, 0, 0, 0);
        day.setDate(today.getDate() + filtersToSend["betbuilder_date_filter"]);
        let dt_from = filtersToSend["betbuilder_date_filter"] >= 0 ? today : day;
        let dt_to = filtersToSend["betbuilder_date_filter"] >= 0 ? day : today;
        filtersToSend["betbuilder_from_date"] = new Date(dt_from).toUTCString();
        filtersToSend["betbuilder_to_date"] = new Date(dt_to).toUTCString();
      } else {
        filtersToSend["betbuilder_from_date"] = null;
        filtersToSend["betbuilder_to_date"] = null;
      }
    } else {
      if (filtersToSend["betbuilder_date_filter"] == 100) {
        if (filtersToSend["betbuilder_from_date"]) {
          let dt =
            filtersToSend["betbuilder_from_date"].getUTCFullYear() +
            "-" +
            (filtersToSend["betbuilder_from_date"].getMonth() + 1 < 10
              ? "0" + (filtersToSend["betbuilder_from_date"].getMonth() + 1)
              : filtersToSend["betbuilder_from_date"].getMonth() + 1) +
            "-" +
            (filtersToSend["betbuilder_from_date"].getDate() < 10
              ? "0" + filtersToSend["betbuilder_from_date"].getDate()
              : filtersToSend["betbuilder_from_date"].getDate()) +
            "T00:00:00Z";
          filtersToSend["betbuilder_from_date"] = new Date(dt).toUTCString();
        }
        if (filtersToSend["betbuilder_to_date"]) {
          let dt =
            filtersToSend["betbuilder_to_date"].getUTCFullYear() +
            "-" +
            (filtersToSend["betbuilder_to_date"].getMonth() + 1 < 10
              ? "0" + (filtersToSend["betbuilder_to_date"].getMonth() + 1)
              : filtersToSend["betbuilder_to_date"].getMonth() + 1) +
            "-" +
            (filtersToSend["betbuilder_to_date"].getDate() < 10
              ? "0" + filtersToSend["betbuilder_to_date"].getDate()
              : filtersToSend["betbuilder_to_date"].getDate()) +
            "T00:00:00Z";
          filtersToSend["betbuilder_to_date"] = new Date(dt).toUTCString();
        }
      }
    }

    if (
      (filtersToSend["bet_settled_date_filter"] || filtersToSend["bet_settled_date_filter"] == 0) &&
      filtersToSend["bet_settled_date_filter"] != 100
    ) {
      if (filtersToSend["bet_settled_date_filter"] != -100) {
        let today = new Date();
        today.setHours(0, 0, 0, 0);
        let day = new Date(today);
        day.setHours(0, 0, 0, 0);
        day.setDate(today.getDate() + filtersToSend["bet_settled_date_filter"]);
        let dt_from = filtersToSend["bet_settled_date_filter"] >= 0 ? today : day;
        let dt_to = filtersToSend["bet_settled_date_filter"] >= 0 ? day : today;
        filtersToSend["bet_settled_from_date"] = new Date(dt_from).toUTCString();
        filtersToSend["bet_settled_to_date"] = new Date(dt_to).toUTCString();
      } else {
        filtersToSend["bet_settled_from_date"] = null;
        filtersToSend["bet_settled_to_date"] = null;
      }
    } else {
      if (filtersToSend["bet_settled_date_filter"] == 100) {
        if (filtersToSend["bet_settled_from_date"]) {
          let dt =
            filtersToSend["bet_settled_from_date"].getUTCFullYear() +
            "-" +
            (filtersToSend["bet_settled_from_date"].getMonth() + 1 < 10
              ? "0" + (filtersToSend["bet_settled_from_date"].getMonth() + 1)
              : filtersToSend["bet_settled_from_date"].getMonth() + 1) +
            "-" +
            (filtersToSend["bet_settled_from_date"].getDate() < 10
              ? "0" + filtersToSend["bet_settled_from_date"].getDate()
              : filtersToSend["bet_settled_from_date"].getDate()) +
            " 00:00:00";
          filtersToSend["bet_settled_from_date"] = new Date(dt).toUTCString();
        }
        if (filtersToSend["bet_settled_to_date"]) {
          let dt =
            filtersToSend["bet_settled_to_date"].getUTCFullYear() +
            "-" +
            (filtersToSend["bet_settled_to_date"].getMonth() + 1 < 10
              ? "0" + (filtersToSend["bet_settled_to_date"].getMonth() + 1)
              : filtersToSend["bet_settled_to_date"].getMonth() + 1) +
            "-" +
            (filtersToSend["bet_settled_to_date"].getDate() < 10
              ? "0" + filtersToSend["bet_settled_to_date"].getDate()
              : filtersToSend["bet_settled_to_date"].getDate()) +
            " 00:00:00";
          filtersToSend["bet_settled_to_date"] = new Date(dt).toUTCString();
        }
      }
    }

    delete filtersToSend["bet_date_filter"];
    delete filtersToSend["betbuilder_date_filter"];
    delete filtersToSend["bet_settled_date_filter"];
    delete filtersToSend["fixture_date_filter"];

    return filtersToSend;
  }

  function linkCell({ value, ...rest }) {
    return (
      <>
        <HtmlTooltip placement="right" title={"Unsettled Odds"}>
          <Button onClick={(e) => handleEditOpenModal(e, rest)}>
            <SoftTypography
              component="span"
              variant="button"
              fontWeight="regular"
              color={"info"}
              opacity={0.8}
              sx={{ lineHeight: 0 }}
            >
              {value}
            </SoftTypography>
          </Button>
        </HtmlTooltip>
      </>
    );
  }

  function formatOrigin({ value, ...rest }) {
    let settler = settlementOrigins.find((item) => item.value == value);
    return settler ? settler.label.split(" ")[0] : " - ";
  }

  function formatStatus({ value, ...rest }) {
    return (
      <>
        <div className={value.replace(/ /g, "_").toLowerCase()}>{value}</div>
      </>
    );
  }

  function formatStatuses({ value, ...rest }) {
    return value ? (
      <HtmlTooltip
        placement="right"
        title={
          <React.Fragment>
            <div style={{}}>
              {value.map((item, index) => {
                return (
                  <div
                    key={rest.row.original.fixtureIds[index] + "-" + item}
                    className={item.replace(/ /g, "_").toLowerCase()}
                  >
                    {item}
                  </div>
                );
              })}
            </div>
          </React.Fragment>
        }
      >
        <div>
          {value.map((item, index) => {
            return (
              <div
                key={rest.row.original.fixtureIds[index] + "-" + item}
                className={`${item.replace(/ /g, "_").toLowerCase()} settlement-provider`}
              >
                {item}
              </div>
            );
          })}
        </div>
      </HtmlTooltip>
    ) : (
      <></>
    );
  }

  function formatProvider({ value, ...rest }) {
    let selectedFixture = rest.row.original;
    return (
      <>
        {value.map((item, index) => {
          let provider = availableProviders.find((p) => p.value === item);
          let providerName = provider ? provider["info"] : item;

          return (
            <div key={index} className="flexy">
              <div
                key={item + "-" + rest.row.original.fixtureIds[index]}
                className={`provider-${providerName} settlement-provider`}
              >
                {providerName}
              </div>
              <Icon
                style={{ display: item == 2 ? "" : "none", cursor: "pointer" }}
                className={`provider-${providerName} settlement-provider`}
                onClick={(e) =>
                  searchVbet(
                    e,
                    selectedFixture
                      ? selectedFixture.fixtureIds[
                          selectedFixture.providers.findIndex((item) => item == 2)
                        ]
                      : null
                  )
                }
              >
                search_icon
              </Icon>
            </div>
          );
        })}
      </>
    );
  }

  function joinArrays({ value, ...rest }) {
    const platforms = Array.isArray(value) ? value : [];
    const betIds = Array.isArray(rest?.row?.original?.betIds) ? rest.row.original.betIds : [];
    const rowCount = betIds.length > 0 ? betIds.length : platforms.length > 0 ? platforms.length : 1;

    return (
      <>
        {[...Array(rowCount)].map((_, index) => {
          const item = platforms[index];
          const hasValue = item !== null && item !== undefined && item !== "";

          if (!hasValue) {
            return (
              <div key={`platform-empty-${index}`} className="settlement-provider">
                <span style={{ opacity: "0.45" }}>-</span>
              </div>
            );
          }

          return (
            <div key={`platform-${item}-${index}`} className="settlement-provider">
              {item}
            </div>
          );
        })}
      </>
    );
  }

  function joinBets({ value, ...rest }) {
    const betIds = Array.isArray(value) ? value : [];
    const amounts = Array.isArray(rest?.row?.original?.amounts) ? rest.row.original.amounts : [];

    if (betIds.length === 0) return <>-</>;

    return (
      <>
        {betIds.map((item, index) => {
          const hasValue = item !== null && item !== undefined && item !== "";

          if (!hasValue) {
            return (
              <div key={`bet-empty-${index}`} className="settlement-provider">
                <span style={{ opacity: "0.45" }}>-</span>
              </div>
            );
          }

          return (
            <div key={`${item}-${index}`} className="settlement-provider">
              <span
                style={{ cursor: "pointer" }}
                className=""
                onClick={(e) => openAdvancedSearch(e, ["bet_id", item])}
              >
                {item}
              </span>
              {amounts[index] !== null && amounts[index] !== undefined ? (
                <span style={{ fontSize: "11px" }}>({amounts[index]})</span>
              ) : null}
              <Icon className="info-icon" onClick={(e) => handleUUIDCopy(e, item)}>
                copy
              </Icon>
            </div>
          );
        })}
      </>
    );
  }

  function joinBetbuilderIds({ value, ...rest }) {
    const betIds = Array.isArray(rest?.row?.original?.betIds) ? rest.row.original.betIds : [];
    let betbuilderIds = [];

    if (Array.isArray(value)) {
      betbuilderIds = value;
    } else if (value && typeof value === "object") {
      if (betIds.length > 0) {
        betbuilderIds = betIds.map((betId) => {
          const mapped = value?.[betId] ?? value?.[`${betId}`];

          if (mapped && typeof mapped === "object") {
            return mapped.betbuilder_id ?? mapped.betbuilderId ?? mapped.id ?? null;
          }

          return mapped ?? null;
        });
      } else {
        betbuilderIds = Object.values(value).map((item) => {
          if (item && typeof item === "object") {
            return item.betbuilder_id ?? item.betbuilderId ?? item.id ?? null;
          }

          return item;
        });
      }
    } else if (value !== null && value !== undefined && value !== "") {
      betbuilderIds = [value];
    }

    if (betbuilderIds.length === 0) return <>-</>;

    return (
      <>
        {betbuilderIds.map((item, index) => {
          const hasValue = item !== null && item !== undefined && item !== "";

          if (!hasValue) {
            return (
              <div key={`betbuilder-empty-${index}`} className="settlement-provider">
                <span style={{ opacity: "0.45" }}>-</span>
              </div>
            );
          }

          return (
            <div key={`${item}-${index}`} className="settlement-provider">
              <HtmlTooltip
                placement="top"
                title={
                  <React.Fragment>
                    <div style={{}}>{item.toString()}</div>
                  </React.Fragment>
                }
              >
                <span
                  style={{ cursor: "pointer" }}
                  onClick={(e) => openAdvancedSearch(e, ["betbuilder_id", item])}
                >
                  {item.toString().substring(0, 10) + "..."}
                </span>
              </HtmlTooltip>
              <Icon className="info-icon" onClick={(e) => handleUUIDCopy(e, item)}>
                copy
              </Icon>
            </div>
          );
        })}
      </>
    );
  }

  function formatDate({ value, ...rest }) {
    let date = new Date(value * 1);
    // let day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
    // let month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
    // let hours = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
    // let minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();

    // let dateformatted = day + "/" + month + "/" + date.getFullYear() + " " + hours + ":" + minutes;
    let dateformatted = formatUTCTostring(value);
    let timezone = (date.getTimezoneOffset() * -1) / 60;
    timezone = timezone > 0 ? "+" + timezone : timezone;
    let alt_start_date_utc_exist =
      rest.row.original.alt_start_date_utc && value !== rest.row.original.alt_start_date_utc
        ? true
        : false;
    return alt_start_date_utc_exist ? (
      <HtmlTooltip
        placement="right"
        title={
          <React.Fragment>
            <div style={{}}>
              {rest.row.original.start_dates_utc.map((item, index) => {
                let itemFormatted = formatUTCTostring(item);
                return (
                  <div key={rest.row.original.fixtureIds[index] + "-" + item}>{itemFormatted}</div>
                );
              })}
            </div>
          </React.Fragment>
        }
      >
        <div style={{ color: "orange" }}>{dateformatted}*</div>
      </HtmlTooltip>
    ) : (
      dateformatted
    );
  }

  function formatMultiUTC({ value, ...rest }) {
    return value.length > 0 ? (
      <div>
        {value.map((item_date, index) => {
          const dateString = item_date;
          return (
            <div key={rest.column.id + "-" + index} style={{ borderBottom: "1px solid #cecece" }}>
              {formatDateStringUTCtoLocaleCell({ value: dateString, ...rest })}
            </div>
          );
        })}
      </div>
    ) : (
      "-"
    );
  }

  function formatDateStringUTCtoLocale(value) {
    if (!value) return "-";
    let date = new Date(value);
    let day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
    let month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
    let hours = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
    let minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
    let secs = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
    let milisecs =
      date.getMilliseconds() < 100
        ? "0" + date.getMilliseconds()
        : date.getMilliseconds() < 10
        ? "00" + date.getMilliseconds()
        : date.getMilliseconds();

    let dateformatted =
      day +
      "/" +
      month +
      "/" +
      date.getFullYear() +
      " " +
      hours +
      ":" +
      minutes +
      ":" +
      secs +
      "." +
      milisecs;
    return dateformatted;
  }

  function formatDateStringUTCtoLocaleCell({ value, ...rest }) {
    if (!value) return "-";
    let date = new Date(value);
    let dateformatted = formatDateStringUTCtoLocale(value);

    let timezone = (date.getTimezoneOffset() * -1) / 60;
    timezone = timezone > 0 ? "+" + timezone : timezone;
    let operator =
      rest.column.id == "settlement_date" ? rest.row.original.settled_by_operator : false;

    let betdate = rest.column.id == "created_at" ? true : false;
    let betMoment = null;
    if (betdate) {
      betMoment = "pre";
      if (date.getTime() > rest.row.original.start_date_utc * 1) betMoment = "live";
    }
    return (
      <div className={betMoment ? betMoment + "-bet" : ""}>
        {dateformatted}
        <Icon style={{ display: operator ? "" : "none", color: "#17c1e8" }}>person_icon</Icon>
      </div>
    );
  }

  function formatSettler({ value, ...rest }) {
    let listItems = rest.row.original.votes;
    let listItemsDiscarded = rest.row.original.votes?.filter((v) => v.discarded == true);
    let listItemsNormal = rest.row.original.votes?.filter((v) => !v.discarded);

    let settlementType = value ? value.split(": ")[0] : null;
    let settler = value ? value.split(": ")[1] : null;
    return value ? (
      <>
        <div>{settlementType}:</div>
        <div style={{ display: settlementType == "operator" ? "" : "none", color: "#17c1e8" }}>
          {settler ? settler : " - "}
        </div>
        <div
          style={{
            display: settler == "offline" ? "" : "none",
            color: settler == "offline" ? "black" : "green",
          }}
        >
          {settlementType == "operator" ? "" : settler}
        </div>
        <div
          style={{
            display: settler == "online" ? "" : "none",
            color: settler == "offline" ? "black" : "green",
          }}
        >
          {settler}
        </div>
        <>
          <HtmlTooltip
            placement="right"
            title={
              <React.Fragment>
                {!listItems || listItems.length == 0
                  ? "No Votes Exist."
                  : listItems?.map((item, index) => {
                      let provider = availableProviders.find((p) => p.value === item.providerId);
                      let providerName = provider ? provider["info"] : item.providerId;
                      let voteDate = new Date(item.timestamp);
                      return (
                        <div
                          key={index}
                          style={{
                            opacity: item.discarded ? "60%" : "100",
                            color: item.discarded ? "red" : "",
                            width: "max-content",
                            display: "inline-flex",
                          }}
                        >
                          <div className={"provider-" + providerName + "-inverse provider-inverse"}>
                            {providerName}
                          </div>
                          <div>
                            {": "}
                            <span style={{ display: "inline-block", minWidth: "100px" }}>
                              {settlementOutcomes.find((s) => s.value == item.outcomeId).label}
                            </span>
                            {item.originId == 1 ? (
                              <span
                                style={{
                                  color: "#66d432",
                                  display: "inline-block",
                                  minWidth: "150px",
                                }}
                              >
                                Online Settlement
                              </span>
                            ) : item.originId == 2 ? (
                              <span
                                style={{
                                  color: "#d432bb",
                                  display: "inline-block",
                                  minWidth: "150px",
                                }}
                              >
                                Offline Settlement
                              </span>
                            ) : item.originId == 4 ? (
                              <span
                                style={{
                                  color: "#f9d900",
                                  display: "inline-block",
                                  minWidth: "150px",
                                }}
                              >
                                FastTrack
                              </span>
                            ) : (
                              <span
                                style={{
                                  color: "#3acaeb",
                                  display: "inline-block",
                                  minWidth: "150px",
                                }}
                              >
                                Operator
                              </span>
                            )}{" "}
                            ({formatDateStringUTCtoLocale(item.timestamp)})
                          </div>
                        </div>
                      );
                    })}
              </React.Fragment>
            }
          >
            <Button
              style={{
                padding: 0,
                padding: "0px",
                width: "30px",
                maxWidth: "30px",
                minWidth: "10px",
                color: rest.row.original.votes ? "" : "red",
              }}
              onClick={(e) => getVotes(e, rest.row.original.uuid)}
            >
              <span style={{ paddingLeft: "5px" }}> </span>
              <Icon>how_to_vote_icon </Icon>
            </Button>
          </HtmlTooltip>
        </>
      </>
    ) : (
      <>
        {" "}
        -
        <>
          <HtmlTooltip
            style={{ minWidth: "600px" }}
            placement="right"
            title={
              <React.Fragment>
                {!listItems || listItems.length == 0
                  ? "No Votes Exist."
                  : listItems.map((item, index) => {
                      let provider = availableProviders.find((p) => p.value === item.providerId);
                      let providerName = provider ? provider["info"] : item.providerId;
                      let voteDate = new Date(item.timestamp);
                      return (
                        <div key={index} style={{ width: "max-content", display: "inline-flex" }}>
                          <div
                            className={"provider-" + providerName + "-inverse provider-inverse"}
                            style={{ minWidth: "50px" }}
                          >
                            {providerName}
                          </div>
                          <div>
                            {": "}
                            <span style={{ display: "inline-block", minWidth: "100px" }}>
                              {settlementOutcomes.find((s) => s.value == item.outcomeId).label}
                            </span>
                            {item.originId == 1 ? (
                              <span
                                style={{
                                  color: "#66d432",
                                  display: "inline-block",
                                  minWidth: "150px",
                                }}
                              >
                                Online Settlement
                              </span>
                            ) : item.originId == 2 ? (
                              <span
                                style={{
                                  color: "#d432bb",
                                  display: "inline-block",
                                  minWidth: "150px",
                                }}
                              >
                                Offline Settlement
                              </span>
                            ) : item.originId == 4 ? (
                              <span
                                style={{
                                  color: "#f9d900",
                                  display: "inline-block",
                                  minWidth: "150px",
                                }}
                              >
                                FastTrack
                              </span>
                            ) : (
                              <span
                                style={{
                                  color: "#3acaeb",
                                  display: "inline-block",
                                  minWidth: "150px",
                                }}
                              >
                                Operator
                              </span>
                            )}{" "}
                            ({formatDateStringUTCtoLocale(item.timestamp)})
                          </div>
                        </div>
                      );
                    })}
              </React.Fragment>
            }
          >
            <Button
              style={{
                padding: 0,
                padding: "0px",
                width: "30px",
                maxWidth: "30px",
                minWidth: "10px",
                color: rest.row.original.votes ? "" : "red",
              }}
              onClick={(e) => getVotes(e, rest.row.original.uuid)}
            >
              <span style={{ paddingLeft: "5px" }}> </span>
              <Icon>how_to_vote_icon </Icon>
            </Button>
          </HtmlTooltip>
        </>
      </>
    );
  }

  function formatConfirmator({ value, ...rest }) {
    let operator_outcome_id = rest.row.original.operator_outcome_id;

    return (
      <>
        <div
          style={{
            color: value ? "" : "orange",
          }}
        >
          {value
            ? "operator: "
            : operator_outcome_id
            ? "Waiting Confirmation"
            : "Without Confirmation"}
        </div>
        <div
          style={{
            display: value ? "" : "none",
            color: "#17c1e8",
          }}
        >
          {value}
        </div>
      </>
    );
  }

  function formatSearchEngines({ value, ...rest }) {
    let selectedFixture = rest.row.original;
    return (
      <div style={{ borderLeft: "1px solid #cecece" }}>
        <SoftBox style={{ marginLeft: "auto" }}>
          <Button
            className="betfoot-button"
            style={{
              display: selectedFixture
                ? selectedFixture.providers.findIndex((item) => item == 3) > -1
                  ? ""
                  : "none"
                : "none",
              padding: "0.1rem 0.75rem",
            }}
            disabled={!selectedFixture}
            onClick={(e) =>
              searchBetfoot(
                e,
                selectedFixture
                  ? selectedFixture.fixtureIds[
                      selectedFixture.providers.findIndex((item) => item == 3)
                    ]
                  : null,
                selectedFixture ? selectedFixture.sport.replace(/ /g, "-").toLowerCase() : null
              )
            }
          >
            1xbet Results
          </Button>
        </SoftBox>
        <SoftBox style={{ marginLeft: "auto" }}>
          <Button
            className="vbet-button"
            style={{
              display: selectedFixture
                ? selectedFixture.providers.findIndex((item) => item == 2) > -1
                  ? ""
                  : "none"
                : "none",
              padding: "0.1rem 0.75rem",
            }}
            disabled={!selectedFixture}
            onClick={(e) =>
              searchVbet(
                e,
                selectedFixture
                  ? selectedFixture.fixtureIds[
                      selectedFixture.providers.findIndex((item) => item == 2)
                    ]
                  : null
              )
            }
          >
            Vbet Results
          </Button>
        </SoftBox>
        <SoftBox>
          <Button
            className="sofa-button"
            style={{ padding: "0.1rem 0.75rem" }}
            disabled={!selectedFixture}
            onClick={(e) => searchSofa(e, selectedFixture)}
          >
            Search SofaScore
          </Button>
        </SoftBox>
        <SoftBox>
          <Button
            disabled={!selectedFixture}
            onClick={(e) =>
              searchGoogle(
                e,
                selectedFixture ? selectedFixture.home + " vs " + selectedFixture.away : null
              )
            }
          >
            search web
          </Button>
        </SoftBox>
        <SoftBox>
          <Button
            color="warning"
            disabled={!selectedFixture}
            style={{ padding: "0.1rem 0.75rem" }}
            onClick={(e) =>
              searchBetsApi(
                e,
                selectedFixture ? selectedFixture.home + " vs " + selectedFixture.away : null
              )
            }
          >
            search betsApi
          </Button>
        </SoftBox>
      </div>
    );
  }

  function formatSettlementDateDiff({ value, ...rest }) {
    if (!rest.row.original.settlement_date || !value) return "-";

    const diffTime = value;
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
    const diffHours = Math.floor((diffTime - diffDays * 1000 * 60 * 60 * 24) / (1000 * 60 * 60));
    const diffMinutes = Math.floor(
      (diffTime - diffDays * 1000 * 60 * 60 * 24 - diffHours * 1000 * 60 * 60) / (1000 * 60)
    );

    return (
      <>
        <div
        // style={{
        //   display: autoSettlement == "offline" ? "" : "none",
        // }}
        >
          {diffDays < 10 ? "0" + diffDays : diffDays}:{diffHours < 10 ? "0" + diffHours : diffHours}
          :{diffMinutes < 10 ? "0" + diffMinutes : diffMinutes}
        </div>
      </>
    );
  }

  function formatCompetition({ value, ...rest }) {
    let headerName = rest.column.id;
    return <div className={headerName + "-cell"}>{value}</div>;
  }

  function goToScoreboardByEventId({ value, ...rest }) {
    return (
      <>
        {value.map((item, index) => {
          return (
            <div key={index} className="settlement-provider">
              <Icon
                className={
                  blockedIds[`${rest.row.original.providers[index]}:${item}`]
                    ? "success-icon-button"
                    : "error-icon-button"
                }
                style={{ cursor: "pointer" }}
                onClick={(e) =>
                  handleBlockFixture(e, {
                    fixture_id: item,
                    providerId: rest.row.original.providers[index],
                    blocked: blockedIds[`${rest.row.original.providers[index]}:${item}`]
                      ? true
                      : false,
                    rowData: rest.row.original,
                  })
                }
                title={"Block Fixture from Feed"}
              >
                {blockedIds[`${rest.row.original.providers[index]}:${item}`]
                  ? "play_circle_outline_icon"
                  : "do_disturb_icon"}
              </Icon>
              {item}
              <Button
                style={{}}
                className={"sportRadar, success-icon"}
                onClick={(e) => {
                  openScoreBoardW(e, rest.row.original, item, rest.row.original.providers[index]);
                }}
              >
                <Icon>content_paste_search_icon</Icon>
              </Button>
            </div>
          );
        })}
      </>
    );
  }

  function goToScoreboardByUniId({ value, ...rest }) {
    let matched = rest.row.original.matched;

    return value ? (
      <div className="flexy">
        <div style={{ cursor: "pointer" }}>
          <Icon
            className={blockedIds[`1000:${value}`] ? "success-icon-button" : "error-icon-button"}
            style={{ cursor: "pointer" }}
            onClick={(e) =>
              handleBlockFixture(e, {
                fixture_id: value,
                providerId: 1000,
                blocked: blockedIds[`1000:${value}`] ? true : false,
                rowData: rest.row.original,
              })
            }
            title={"Block Fixture from Feed"}
          >
            {blockedIds[`1000:${value}`] ? "play_circle_outline_icon" : "do_disturb_icon"}
          </Icon>
          <span
            className=""
            onClick={(e) =>
              openAdvancedSearch(e, matched ? ["uni_id", value] : ["provider_id", value])
            }
          >
            {value.toString()}
          </span>
          <Icon className="info-icon" onClick={(e) => handleUUIDCopy(e, value)}>
            copy
          </Icon>
        </div>
        <Button
          style={{}}
          className={"sportRadar success-icon"}
          onClick={(e) => {
            openScoreBoardW(e, rest.row.original, value);
          }}
        >
          <Icon>content_paste_search_icon</Icon>
        </Button>
      </div>
    ) : (
      <div></div>
    );
  }

  function showFixtureData({ value, ...rest }) {
    return (
      <>
        {value}
        <Button
          style={{ display: rest.row.original.sportradar_id * 1 ? "" : "none" }}
          className={rest.row.original.sportradar_id ? "sportRadar warning-icon" : ""}
          onClick={(e) => {
            openSportRadarTimeline(e, rest.row.original.sportradar_id, rest.row.original);
          }}
        >
          <Icon>toc_outlined_icon</Icon>
        </Button>
      </>
    );
  }

  function formatUuid({ value, ...rest }) {
    return (
      <HtmlTooltip
        placement="top"
        title={
          <React.Fragment>
            <div style={{}}>{value.toString()}</div>
          </React.Fragment>
        }
      >
        <div style={{ cursor: "pointer" }}>
          <span className="info-icon" onClick={(e) => setExternalSearch(value)}>
            {value.toString().substring(0, 10) + "..."}
          </span>
          <Icon className="info-icon" onClick={(e) => handleUUIDCopy(e, value)}>
            copy
          </Icon>
        </div>
      </HtmlTooltip>
    );
  }

  function formatUTCTostring(value) {
    let date = new Date(value * 1);
    let day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
    let month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
    let hours = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
    let minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();

    let dateformatted = day + "/" + month + "/" + date.getFullYear() + " " + hours + ":" + minutes;
    return dateformatted;
  }

  function formatDateStringToString(value) {
    let date = new Date(value);
    let day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
    let month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
    let hours = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
    let minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();

    let dateformatted = day + "/" + month + "/" + date.getFullYear() + " " + hours + ":" + minutes;
    return dateformatted;
  }

  function possibleSettlement({ value, ...rest }) {
    let outcome_id = value && value != "null" ? value : rest.row.original.operator_outcome_id;

    return rest.row.original.confirmed ? (
      <div style={{ display: "flex" }}>
        <div>
          <SoftSelect
            className="settlement-outcomes"
            style={{ width: "120px !important" }}
            customSmall={true}
            value={settlementOutcomes.find((item) => item.value === outcome_id)}
            options={settlementOutcomes}
            onChange={(value) => handleSettlementOutcomeChange(value, rest.row)}
          ></SoftSelect>
        </div>
        <div>
          <div>
            <HtmlTooltip
              placement="right"
              title={
                <React.Fragment>
                  <div style={{ display: "flex", flexWrap: "wrap" }}>Confirmed</div>
                </React.Fragment>
              }
            >
              <Button style={{ margin: "auto", padding: "2px" }}>
                <Icon style={{ color: "green", opacity: "0.4" }}>verified_icon</Icon>
              </Button>
            </HtmlTooltip>
          </div>
          <div style={{ display: rest.row.original.sent ? "none" : "" }}>
            <HtmlTooltip
              placement="right"
              title={
                <React.Fragment>
                  <div style={{ display: "flex", flexWrap: "wrap" }}>
                    New Settlement Data Exist. You may check Again Settlement
                  </div>
                </React.Fragment>
              }
            >
              <Button
                style={{
                  margin: "auto",
                  padding: "2px",
                }}
                onClick={(e) =>
                  outcome_id ? openInNewWindow(e, "/settlement/confirmations") : null
                }
              >
                <Icon style={{ color: "orange" }}>security_icon</Icon>
              </Button>
            </HtmlTooltip>
          </div>
          <div style={{ display: outcome_id ? "" : "none" }}>
            <HtmlTooltip
              placement="right"
              title={
                <React.Fragment>
                  <div style={{ display: "flex", flexWrap: "wrap" }}>Resend Settlement</div>
                </React.Fragment>
              }
            >
              <Button
                style={{
                  margin: "auto",
                  padding: "2px",
                }}
              >
                <Icon
                  style={{ color: "rgb(203, 12, 159)" }}
                  onClick={(e) => (outcome_id ? resendSettlement(e, rest.row.original) : null)}
                >
                  send_icon
                </Icon>
              </Button>
            </HtmlTooltip>
          </div>
        </div>
      </div>
    ) : (
      <div style={{ display: "flex" }}>
        <div>
          <SoftSelect
            className="settlement-outcomes"
            style={{ width: "120px !important" }}
            customSmall={true}
            value={settlementOutcomes.find((item) => item.value === outcome_id)}
            options={settlementOutcomes}
            onChange={(value) => handleSettlementOutcomeChange(value, rest.row)}
          ></SoftSelect>
        </div>
        <div>
          <HtmlTooltip
            placement="right"
            title={
              <React.Fragment>
                <div style={{ display: "flex", flexWrap: "wrap" }}>
                  {rest.row.original.operator_outcome_id
                    ? "Waiting for Confirmation!"
                    : outcome_id
                    ? "Without Confirmation"
                    : "Waiting for Settlement!"}
                </div>
              </React.Fragment>
            }
          >
            <Button
              style={{
                margin: "auto",
                padding: "2px",
              }}
              onClick={(e) => (outcome_id ? openInNewWindow(e, "/settlement/confirmations") : null)}
            >
              <Icon style={{ color: rest.row.original.operator_outcome_id ? "orange" : "#cecece" }}>
                {" "}
                {rest.row.original.operator_outcome_id
                  ? "security_icon"
                  : rest.row.original.outcome_id
                  ? "verified_user_icon"
                  : "border_color_icon"}{" "}
              </Icon>
            </Button>
          </HtmlTooltip>
          <div
            style={{
              display: outcome_id ? (rest.row.original.operator_outcome_id ? "none" : "") : "none",
            }}
          >
            <HtmlTooltip
              placement="right"
              title={
                <React.Fragment>
                  <div style={{ display: "flex", flexWrap: "wrap" }}>Resend Settlement</div>
                </React.Fragment>
              }
            >
              <Button
                style={{
                  margin: "auto",
                  padding: "2px",
                }}
              >
                <Icon
                  style={{ color: "rgb(203, 12, 159)" }}
                  onClick={(e) => (outcome_id ? resendSettlement(e, rest.row.original) : null)}
                >
                  send_icon
                </Icon>
              </Button>
            </HtmlTooltip>
          </div>
        </div>
      </div>
    );
  }

  function possibleSettlements({ value, ...rest }) {
    {
      return value.map((item, index) => {
        let outcome_id = item;
        return outcome_id ? (
          <div
            key={rest.row.original.uuid + " - " + rest.row.original.betIds[index]}
            style={{ display: "flex" }}
          >
            <div>
              <HtmlTooltip
                placement="right"
                title={
                  <React.Fragment>
                    <div style={{ display: "flex", flexWrap: "wrap" }}>FAKE SETTLE</div>
                  </React.Fragment>
                }
              >
                <Button
                  className="fake-settle-icon-button"
                  style={{
                    margin: "auto",
                    padding: "2px",
                    marginRight: "5px",
                  }}
                  onClick={(e) =>
                    setFakeSettlement(e, {
                      uuid: rest.row.original.uuid,
                      betId: rest.row.original.betIds[index],
                    })
                  }
                >
                  <Icon style={{ color: "green", opacity: "0.4" }}>verified_icon</Icon>
                </Button>
              </HtmlTooltip>
            </div>
            <div>
              <SoftSelect
                className="bet-odd-settlement-outcomes"
                style={{ width: "120px !important" }}
                customSmall={true}
                defaultValue={settlementOutcomes.find((item) => item.value === outcome_id)}
                options={settlementOutcomes}
                onChange={(value) =>
                  handleBetOddSettlementOutcomeChange(value, index, rest.row.original)
                }
              ></SoftSelect>
            </div>
            <div>
              <HtmlTooltip
                placement="right"
                title={
                  <React.Fragment>
                    <div style={{ display: "flex", flexWrap: "wrap" }}>Resend Settlement</div>
                  </React.Fragment>
                }
              >
                <Button
                  style={{
                    margin: "auto",
                    padding: "2px",
                  }}
                >
                  <Icon
                    style={{ color: outcome_id ? "rgb(203, 12, 159)" : "#cecece" }}
                    onClick={(e) =>
                      outcome_id ? resendBetOddSettlement(e, rest.row.original, index) : null
                    }
                  >
                    send_icon
                  </Icon>
                </Button>
              </HtmlTooltip>
            </div>
          </div>
        ) : (
          <div
            key={rest.row.original.uuid + " - " + rest.row.original.betIds[index]}
            style={{ display: "flex" }}
          >
            <div>
              <HtmlTooltip
                placement="right"
                title={
                  <React.Fragment>
                    <div style={{ display: "flex", flexWrap: "wrap" }}>FAKE SETTLE</div>
                  </React.Fragment>
                }
              >
                <Button
                  className="fake-settle-icon-button"
                  style={{
                    margin: "auto",
                    padding: "2px",
                    marginRight: "5px",
                  }}
                  onClick={(e) =>
                    setFakeSettlement(e, {
                      uuid: rest.row.original.uuid,
                      betId: rest.row.original.betIds[index],
                    })
                  }
                >
                  <Icon style={{ color: "green", opacity: "0.4" }}>verified_icon</Icon>
                </Button>
              </HtmlTooltip>
            </div>
            <div>
              <SoftSelect
                className="bet-odd-settlement-outcomes"
                style={{ width: "120px !important" }}
                customSmall={true}
                options={settlementOutcomes}
                onChange={(value) =>
                  handleBetOddSettlementOutcomeChange(value, index, rest.row.original)
                }
              ></SoftSelect>
            </div>
            <div>
              <HtmlTooltip
                placement="right"
                title={
                  <React.Fragment>
                    <div style={{ display: "flex", flexWrap: "wrap" }}>Resend Settlement</div>
                  </React.Fragment>
                }
              >
                <Button
                  style={{
                    margin: "auto",
                    padding: "2px",
                  }}
                >
                  <Icon
                    style={{ color: "rgb(203, 12, 159)" }}
                    onClick={(e) =>
                      rest.row.original.operatorOutcomes
                        ? resendBetOddSettlement(e, rest.row.original, index)
                        : null
                    }
                  >
                    send_icon
                  </Icon>
                </Button>
              </HtmlTooltip>
            </div>
          </div>
        );
      });
    }
  }

  function editNotes({ value, ...rest }) {
    return (
      <div style={{ display: "grid" }}>
        <TextField
          className={"multilineTextField"}
          id="outlined-multiline-flexible"
          label="Notes"
          multiline
          maxRows={4}
          defaultValue={value}
          onChange={(e) => setNoteData(e, rest.row)}
        />
        <Button onClick={(e) => sentNotes(e, rest.row.original.note_id)}>sync Notes</Button>
      </div>
    );
  }

  function setNoteData(e, row) {
    e.preventDefault();

    row.original.note = e.currentTarget.value;
  }

  async function sentNotes(e, note_id) {
    e.preventDefault();

    let noteToSend = currentData.rows.find((item) => item.note_id == note_id);

    let setOddNoteEndPoint = `/api/v1/bets/odd/note`;
    let response = await postData(
      setOddNoteEndPoint,
      { id: noteToSend.note_id, note: noteToSend.note },
      {
        Authorization: getAuthorizationHeader(),
      }
    );

    if (response != null) {
      setApiresponse("success");
      setApiResponseMsg("Note succesfully updated!");
      setNotification(true);
    } else {
      setApiresponse("error");
      setApiResponseMsg("Something went wrong! Note doesn't updated. Please try again later. ");
      setNotification(true);
    }

    // console.log(noteToSend);
  }

  async function openSportRadarTimeline(e, sportRadarId, fixture) {
    e.preventDefault();
    e.stopPropagation();
    setApiresponse("info");
    setApiResponseMsg("Searching for Timeline");
    setNotification(true);
    let getSportRadarTimelineEndpoint = `/api/v1/statistics/timeline?sportRadarId=${sportRadarId}`;
    let response = await getData(getSportRadarTimelineEndpoint, {
      Authorization: getAuthorizationHeader(),
    });

    if (response != null) {
      if (response.data.length > 0) {
        setTimelineEvent(fixture);
        setSelectedTimeline(response.data);
        handleOpenTimeline(e, fixture);
        setApiresponse("success");
        setApiResponseMsg("Timeline Loaded.");
        setNotification(true);
      } else {
        setApiresponse("error");
        setApiResponseMsg("Timeline not Found");
        setNotification(true);
      }
    }
  }

  async function openScoreBoardW(e, data, eventId, provider) {
    e.preventDefault();
    e.stopPropagation();
    setApiresponse("info");
    setApiResponseMsg("Searching for ScoreBoard");
    setNotification(true);
    let providerId = provider ? provider : 1000;
    let competitionId = data.competition_id ? data.competition_id : "*";
    let id = eventId;
    let type = "inplay";
    let sport = data.sport.toLowerCase();

    let getOddsEndpoint = `/api/v1/keys/fixtures/${type}/${sport}`;
    getOddsEndpoint = `${getOddsEndpoint}/${competitionId}/${providerId}/${id}`;

    let response = await getData(getOddsEndpoint, {
      Authorization: getAuthorizationHeader(),
    });

    if (response != null) {
      if (response.data && response.data.live) {
        data.provider_name = availableProviders.find((p) => p.value === providerId)["info"];
        data.fixture_id = eventId;
        setTimelineEvent(data);
        setSelectedScoreboard(response.data.live.scoreBoard);
        handleOpenScoreboard(e, response.data.live.scoreBoard);
        setApiresponse("success");
        setApiResponseMsg("Scoreboad Loaded.");
        setNotification(true);
      } else {
        setApiresponse("error");
        setApiResponseMsg("Scoreboad not Found");
        setNotification(true);
      }
    } else {
    }
  }

  const handleOpenTimeline = (event) => {
    setOpenTimeline(event.target);
  };

  const handleCloseTimeline = () => setOpenTimeline(false);

  const handleOpenScoreboard = (event) => {
    setOpenScoreboard(event.target);
  };

  const handleCloseScoreboard = () => setOpenScoreboard(false);

  // Render the notifications menu
  const renderTimeline = () =>
    selectedTimeline && selectedTimeline.length > 0 ? (
      <Menu
        anchorEl={openTimeline}
        anchorReference={null}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        open={Boolean(openTimeline)}
        onClose={handleCloseTimeline}
        sx={{ mt: 2 }}
        className="timeline-holder"
      >
        <li
          key={timelineEvent.id}
          style={{
            position: "fixed",
            background: "rgb(233, 236, 239)",
            zIndex: 1401,
            borderRadius: "10px",
            padding: "10px",
            minWidth: "280px",
            textAlign: "center",
          }}
        >
          <div>
            <SoftTypography variant="caption" style={{ marginRight: "auto", fontWeight: 700 }}>
              {timelineEvent.sport}
            </SoftTypography>
            <SoftTypography variant="caption" style={{ margin: "10px" }}>
              -
            </SoftTypography>
            <SoftTypography variant="caption" style={{ marginRight: "auto", fontWeight: 700 }}>
              {timelineEvent.provider_name}
            </SoftTypography>
            <SoftTypography variant="caption" style={{ margin: "10px" }}>
              -
            </SoftTypography>
            <SoftTypography variant="caption">
              {timelineEvent.fixture_id ? timelineEvent.fixture_id : timelineEvent.event_id}
            </SoftTypography>
          </div>
          <div>
            <SoftTypography style={{}} variant="caption">
              {timelineEvent.home}
            </SoftTypography>
            <SoftTypography variant="caption" style={{ margin: "10px" }}>
              Vs
            </SoftTypography>
            <SoftTypography variant="caption">{timelineEvent.away}</SoftTypography>
          </div>
          <DownloadJSON
            data={selectedTimeline}
            fileName={
              timelineEvent.fixture_id
                ? "timeline-events@" + timelineEvent.fixture_id
                : "timeline-events@" + timelineEvent.event_id
            }
          ></DownloadJSON>
        </li>
        <li key={timelineEvent.id + "1"}>&nbsp;</li>
        <li key={timelineEvent.id + "2"}>&nbsp;</li>
        <li key={timelineEvent.id + "3"}>&nbsp;</li>
        <li key={timelineEvent.id + "4"}>&nbsp;</li>
        <li key={timelineEvent.id + "5"}>&nbsp;</li>
        <li key={timelineEvent.id + "6"}>&nbsp;</li>
        {selectedTimeline.map((item) => (
          <HtmlTooltip
            key={item._id}
            placement="right"
            title={
              <React.Fragment>
                <div style={{ display: "flex", flexWrap: "wrap" }}>
                  more Info for this Timeline-Event:{" "}
                </div>
                {Object.keys(item).map((k, index) => (
                  <div key={item._id + "-" + index + "more_info"}>
                    {k + ": " + (item[k] ? JSON.stringify(item[k]) : "")}
                  </div>
                ))}
              </React.Fragment>
            }
          >
            <NotificationItem
              className={
                item.team == "home"
                  ? "timeline-item-left"
                  : item.team == "away"
                  ? "timeline-item-right"
                  : "timeline-item-middle"
              }
              sx={{ width: "100%" }}
              // image={
              //   <img alt="participant">
              //     {item.team == "home" ? "H" : item.team == "away" ? "A" : ""}
              //   </img>
              // }
              //title={[item.name]}
              info={[item.name]}
              date={item.time == -1 ? null : item.time + "'"}
              side={item.team}
              data={item}
            />
          </HtmlTooltip>
        ))}
      </Menu>
    ) : (
      ""
    );

  const renderScoreboard = () =>
    selectedScoreboard ? (
      <Menu
        anchorEl={openScoreboard}
        anchorReference={null}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        open={Boolean(openScoreboard)}
        onClose={handleCloseScoreboard}
        sx={{ mt: 2 }}
        className="timeline-holder"
      >
        <li
          key={timelineEvent.id}
          style={{
            position: "fixed",
            background: "rgb(233, 236, 239)",
            zIndex: 1401,
            borderRadius: "10px",
            padding: "10px",
            minWidth: "280px",
            textAlign: "center",
          }}
        >
          <div>
            <SoftTypography variant="caption" style={{ marginRight: "auto", fontWeight: 700 }}>
              {timelineEvent.sport}
            </SoftTypography>
            <SoftTypography variant="caption" style={{ margin: "10px" }}>
              -
            </SoftTypography>
            <SoftTypography variant="caption" style={{ marginRight: "auto", fontWeight: 700 }}>
              {timelineEvent.provider_name}
            </SoftTypography>
            <SoftTypography variant="caption" style={{ margin: "10px" }}>
              -
            </SoftTypography>
            <SoftTypography variant="caption">
              {timelineEvent.fixture_id ? timelineEvent.fixture_id : timelineEvent.event_id}
            </SoftTypography>
          </div>
          <div>
            <SoftTypography style={{}} variant="caption">
              {timelineEvent.home}
            </SoftTypography>
            <SoftTypography variant="caption" style={{ margin: "10px" }}>
              Vs
            </SoftTypography>
            <SoftTypography variant="caption">{timelineEvent.away}</SoftTypography>
          </div>
          <DownloadJSON
            data={selectedScoreboard}
            fileName={
              timelineEvent.fixture_id
                ? "timeline-events@" + timelineEvent.fixture_id
                : "timeline-events@" + timelineEvent.event_id
            }
          ></DownloadJSON>
        </li>
        <li key={timelineEvent.id + "1"}>&nbsp;</li>
        <li key={timelineEvent.id + "2"}>&nbsp;</li>
        <li key={timelineEvent.id + "3"}>&nbsp;</li>
        <li key={timelineEvent.id + "4"}>&nbsp;</li>
        <li key={timelineEvent.id + "5"}>&nbsp;</li>
        <li key={timelineEvent.id + "6"}>&nbsp;</li>
        <SoftBox
          display=" flex"
          flexDirection="column"
          justifyContent="space-between"
          alignItems="flex-start"
          p={1}
        >
          <Grid item sm={12} sx={{ width: "100%" }}>
            {selectedScoreboard
              ? Object.keys(selectedScoreboard).map((scItem, i) => {
                  if (
                    !selectedScoreboard[scItem] ||
                    !selectedScoreboard[scItem].hasOwnProperty("h") ||
                    selectedScoreboard[scItem].h == -1
                  )
                    return "";
                  return (
                    <Grid
                      container
                      key={"scoreboard-type-" + i}
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        marginBottom: "5px",
                        paddingBottom: "15px",
                        backgroundColor: "#ffffff60",
                      }}
                    >
                      <Grid item sm={12}>
                        <SoftTypography className={"scoreboard-type"}>{scItem}</SoftTypography>
                      </Grid>
                      <Grid item sm={12} sx={{ display: "flex" }}>
                        <Grid
                          item
                          sm={6}
                          sx={{ paddingRight: "2px", paddingLeft: "5px", width: "100%" }}
                        >
                          <Grid item sm={12}>
                            <SoftTypography className={"scoreboard-value"}>
                              {selectedScoreboard[scItem].h}
                            </SoftTypography>
                          </Grid>
                          <Grid item sm={12} sx={{ transform: "rotate(180deg)" }}>
                            <SoftProgress
                              className="live-stats-bars"
                              style={{
                                height: "5px",
                                backgroundColor: "#ffffff80",
                              }}
                              variant="contained"
                              color="info"
                              value={
                                selectedScoreboard[scItem].h > 0
                                  ? (100 * selectedScoreboard[scItem].h) /
                                    (selectedScoreboard[scItem].h + selectedScoreboard[scItem].g)
                                  : 0
                              }
                            />
                          </Grid>
                        </Grid>
                        <Grid
                          item
                          sm={6}
                          sx={{ paddingLeft: "2px", paddingRight: "5px", width: "100%" }}
                        >
                          <Grid item sm={12}>
                            <SoftTypography className={"scoreboard-value"}>
                              {selectedScoreboard[scItem].g}
                            </SoftTypography>
                          </Grid>
                          <Grid item sm={12}>
                            <SoftProgress
                              style={{
                                height: "5px",
                                backgroundColor: "#ffffff80",
                              }}
                              variant="contained"
                              color="success"
                              value={
                                selectedScoreboard[scItem].g > 0
                                  ? (100 * selectedScoreboard[scItem].g) /
                                    (selectedScoreboard[scItem].h + selectedScoreboard[scItem].g)
                                  : 0
                              }
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  );
                })
              : ""}
          </Grid>
        </SoftBox>
      </Menu>
    ) : (
      ""
    );

  const handleSettlementOutcomeChange = async (item, row) => {
    setUpdateEnabled(false);
    setHiddenColumns([]);
    setDataTableData({ columns: [], rows: [] });
    //console.log("Settlement Change: ", item.value, " for odd: ", row.original.uuid);

    // const data = { ...dataTableData };
    // setDataTableData(data);
    // data.rows = [...currentData];
    // const dataRow = data.rows.find((item) => {
    //   return (item.uuid = row.original.uuid);
    // });
    if (!currentData.rows) return;
    let dataRow = currentData.rows.find((item) => item.uuid == row.original.uuid);
    if (!dataRow.hasOwnProperty("outcome_id_init")) {
      row.original.outcome_id_init = dataRow.outcome_id;
      dataRow.outcome_id_init = dataRow.outcome_id;
    }
    dataRow.updated = "updated";
    row.original.updated = "updated";
    dataRow.outcome_id = item.value;
    setHiddenColumns(["tm", "updated", "provider_names"]);

    const settlement = {
      uuid: row.original.uuid,
      outcome_id: item.value,
      event_id: row.original.uni_id ? row.original.uni_id : row.original.event_id,
      provider_id: row.original.provider_id,
      sp: row.original.sp,
    };
    const settlementExist = settlements.find((item) => item.uuid === settlement.uuid);
    if (!settlementExist) {
      if (settlement.outcome_id === 0) settlement.outcome_id = null;
      settlements.push(settlement);
    } else {
      let settlementExistIndex = settlements.findIndex(
        (item) => item.uuid === settlementExist.uuid
      );
      if (settlement.outcome_id === 0) {
        settlement.outcome_id = null;
      } else {
        settlementExist.outcome_id = settlement.outcome_id;
      }
      if (settlementExist.outcome_id == dataRow.outcome_id_init) {
        settlements.splice(settlementExistIndex, 1);
      }
    }
    if (settlements.length > 0) {
      setUpdateEnabled(true);
      setApiresponse("success");
      setApiResponseMsg("There are unsaved Odd Settlements changes.");
      setNotification(true);
      setShowDialog(true);
    } else {
      setApiresponse("error");
      setApiResponseMsg("There are NO unsaved Odd Settlements changes.");
      setNotification(true);
      setShowDialog(false);
    }
    setDataTableData(currentData);
  };

  const handleBetOddSettlementOutcomeChange = async (item, index, row) => {
    //console.log("settlement item", item);
    let dataTable = currentData;
    let dataRow = dataTable.rows.find((r) => r.uuid == row.uuid);
    if (dataRow) {
      if (!dataRow.operatorOutcomes) dataRow.operatorOutcomes = [];
      let changeExist = dataRow.operatorOutcomes.find((o) => o.betId == dataRow.betIds[index]);
      if (changeExist) {
        changeExist.value = item.value;
      } else {
        dataRow.operatorOutcomes.push({ betId: dataRow.betIds[index], value: item.value });
      }
    }
  };

  const handleBetsFilters = (filters, reset) => {
    fetchBetsOdds(filters, reset);
  };

  const handleCancelEdit = async () => {
    if (settlements.length > 0) {
      Swal.fire({
        title: `Unsaved Data!`,
        html: `You are going Lose some Odds you have already settle. </br></br><SoftBox pr={1} style={{ marginRight: "auto" }}>
            <SoftTypography variant="caption">${settlements.length}</SoftTypography>
            <SoftTypography variant="caption"> - </SoftTypography>
            <SoftTypography variant="caption" style="color:#cb0c9f">
              odd Settlements changes
            </SoftTypography>
          </SoftBox></br></br>Are you Sure?`,
        showDenyButton: true,
        showConfirmButton: true,
        confirmButtonText: "Yes, Cancel them!",
        denyButtonText: "Cancel",
        icon: "warning",
        confirmButtonColor: "#87cb16",
        denyButtonColor: "#ff4a55",
      }).then(async (result) => {
        if (result.isConfirmed) {
          //console.log("Modal confirmed");
          setUpdateEnabled(true);
          setUpdateEnabled(false);
          resetData();
          setShowDialog(false);
        }
      });
    } else {
      //console.log("Nothing have been changed");
    }
  };

  async function resetData() {
    settlements = [];
    if (applyFilters) setApplyFilters(false);
    if (!applyFilters) setApplyFilters(true);
    setShowDialog(false);
  }

  const sleep = (ms) =>
    new Promise((resolve) => {
      setTimeout(resolve, ms);
    });

  const handleUpdate = () => {
    Swal.fire({
      title: `Unsaved Data!`,
      html: `You are going to Settle a number of Odds. </br></br><SoftBox pr={1} style={{ marginRight: "auto" }}>
            <SoftTypography variant="caption">${settlements.length}</SoftTypography>
            <SoftTypography variant="caption"> - </SoftTypography>
            <SoftTypography variant="caption" style="color:#cb0c9f">
              odd Settlements changes
            </SoftTypography>
          </SoftBox></br></br>Are you Sure?`,
      showDenyButton: true,
      showConfirmButton: true,
      confirmButtonText: "Yes, Settle them!",
      denyButtonText: "Cancel",
      icon: "warning",
      confirmButtonColor: "success",
      // denyButtonColor: "#ff4a55",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const settleOddEndPoint = `/api/v1/bets/settleOdd`;
        const settlementOutcomesVar = getSettlements();
        const response = await postData(
          settleOddEndPoint,
          { signal: "evaluation", values: settlementOutcomesVar },
          {
            Authorization: getAuthorizationHeader(),
          }
        );

        if (response != null) {
          Swal.fire("Request Sent!", `Odds Settlements Sent to system.`, "success").then(
            async (result) => {
              setUpdateEnabled(true);
              setUpdateEnabled(false);
              await sleep(2000);

              resetData();
            }
          );
        } else {
          Swal.fire("Error!", `Something went wrong.`, "error").then(async (result) => {
            setUpdateEnabled(true);
            setUpdateEnabled(false);
            resetData();
          });
        }
      }
    });
  };

  /**
   *
   */
  const handleUUIDCopy = (e, UUID) => {
    //console.log("Copy ApiKey: ", apikey);
    copyToClipboard(UUID);
  };

  const copyToClipboard = (textToCopy) => {
    setApiresponse("success");
    setApiResponseMsg("UUID has been copied to the clipboard!");
    setNotification(true);
    // navigator clipboard api needs a secure context (https)
    if (navigator.clipboard && window.isSecureContext) {
      // navigator clipboard api method'
      return navigator.clipboard.writeText(textToCopy);
    } else {
      // text area method
      let textArea = document.createElement("textarea");
      textArea.value = textToCopy;
      // make the textarea out of viewport
      textArea.style.position = "fixed";
      textArea.style.left = "-999999px";
      textArea.style.top = "-999999px";
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      return new Promise((res, rej) => {
        // here the magic happens
        document.execCommand("copy") ? res() : rej();
        textArea.remove();
      });
    }
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setNotification(false);
  };

  const getSettlements = () => {
    return settlements;
  };

  const viewChanges = () => {
    let currentMode = modeChanges;
    if (modeChanges) {
      setModeChanges(false);
    } else {
      setModeChanges(true);
    }
    setHiddenColumns([]);
    setDataTableData({ columns: [], rows: [] });

    if (currentMode) {
      let filteredData = { ...originalData };

      setHiddenColumns(["tm", "updated", "provider_names"]);
      setDataTableData(filteredData);
    } else {
      originalData = { ...currentData };

      let filteredData = { ...currentData };

      filteredData.rows = currentData.rows.filter((item) => {
        return item.updated === "updated";
      });
      setHiddenColumns(["tm", "updated", "provider_names"]);
      setDataTableData(filteredData);
    }
  };

  function searchGoogle(e, verd) {
    e.preventDefault();
    var q = verd;
    window.open("http://google.com/search?q=" + q);
  }

  function searchBetsApi(e, verd) {
    e.preventDefault();
    var q = verd;
    window.open("https://betsapi.com/search/?q=" + q.split(" vs ")[0]);
  }

  function searchVbet(e, id) {
    e.preventDefault();
    window.open("https://sport.vbet.am/en/sports/pre-match/results?game=" + id);
  }

  function searchBetfoot(e, id, sport) {
    e.preventDefault();
    if (id && sport) window.open(`https://betfoot.com/live/${sport}/1/${id}`);
  }

  function searchSofa(e, fixture) {
    e.preventDefault();
    let sport = fixture.sport.toLowerCase();
    let home = fixture.home;
    let url = `https://duckduckgo.com/?q=!ducky+inurl:sofascore.com/team/${sport}  ${home}`;
    window.open(url.toString(), "_blank", "noreferrer");
  }

  function openAdvancedSearch(e, data) {
    e.preventDefault();

    window.open("/settlement/advanced?" + data[0] + "=" + data[1]);
  }

  function setFakeSettlement(e, data) {
    e.preventDefault();

    Swal.fire({
      title: `Attention!`,
      html: `You are going to FAKE mark this bet odd for the specific bet as settled. </br></br>Are you Sure?`,
      showDenyButton: true,
      showConfirmButton: true,
      confirmButtonText: "Yes, Mark it as Settled!",
      denyButtonText: "Cancel",
      icon: "warning",
      confirmButtonColor: "success",
      // denyButtonColor: "#ff4a55",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const settleOddEndPoint = `/api/v1/bets/marksettled`;
        const response = await postData(
          settleOddEndPoint,
          { signal: "fake", values: data },
          {
            Authorization: getAuthorizationHeader(),
          }
        );

        if (response != null) {
          Swal.fire("Request Sent!", `Odds Settlements Sent to system.`, "success").then(
            async (result) => {
              resetData();
            }
          );
        } else {
          Swal.fire("Error!", `Something went wrong.`, "error").then(async (result) => {
            resetData();
          });
        }
      }
    });
  }

  function handleExportData() {
    const dataToCSV = {
      data: dataTableData.rows.map((item) => {
        const diffDays = Math.floor(item.diff / (1000 * 60 * 60 * 24));
        const diffHours = Math.floor(
          (item.diff - diffDays * 1000 * 60 * 60 * 24) / (1000 * 60 * 60)
        );
        const diffMinutes = Math.floor(
          (item.diff - diffDays * 1000 * 60 * 60 * 24 - diffHours * 1000 * 60 * 60) / (1000 * 60)
        );

        return {
          "Market Name": item.name,
          "Odd e": item.e,
          "Odd h": item.h,
          "Odd o": item.o,
          "Odd SP": item.sp,
          "Odd Payment %": item.payment_percentage,
          Outcome: item.outcome_id,
          Status: item.statuses,
          Sport: item.sport,
          Providers: item.providers,
          Region: item.region,
          Competition: item.competition,
          Home: item.home,
          Away: item.away,
          "Start Date": formatUTCTostring(item.start_date_utc),
          Platform: item.platforms,
          "Bet Ids": item.betIds,
          "Betbuilder Ids":
            item.betbuilderIds ??
            item.betbuilder_ids ??
            item.betbuilder_id ??
            item.betBuilderIds ??
            item.betBuilderId ??
            item.betbuilderId ??
            "-",
          UUID: item.uuid,
          "Uni ID": item.uni_id,
          "fixture Ids": item.fixtureIds,
          "Bet Date": formatDateStringToString(item.created_at),
          "Settlement Date": item.settlement_date
            ? formatDateStringToString(item.settlement_date)
            : "-",
          "Time Settlement Diff": !item.settlement_date
            ? "-"
            : (diffDays < 10 ? "0" + diffDays : diffDays) +
              ":" +
              (diffHours < 10 ? "0" + diffHours : diffHours) +
              ":" +
              (diffMinutes < 10 ? "0" + diffMinutes : diffMinutes),
          "Settled by": item.settler,
        };
      }),
      filename: `advanced_settlement_report`,
      delimiter: ";",
    };
    csvDownload(dataToCSV);
    setApiresponse("success");
    setApiResponseMsg(`The Report, saved successfully`);
    setNotification(true);
  }

  const informParent = (data) => {
    if (data.key == "search") {
      setExternalSearch(null);
    }
  };

  const resendSettlement = async (e, data) => {
    e.preventDefault();

    Swal.fire({
      title: `Resend Settlement?`,
      html: `You are going to Resend Settlement. </br></br>Are you Sure?`,
      showDenyButton: true,
      showConfirmButton: true,
      confirmButtonText: "Yes",
      denyButtonText: "Cancel",
      icon: "warning",
      confirmButtonColor: "#87cb16",
      denyButtonColor: "#ff4a55",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const settleOddEndPoint = `/api/v1/bets/settlements/resend`;

        const settlementOutcomesVar = {
          uuid: data.uuid,
          outcome_id: data.outcome_id,
          event_id: data.fixture_id ? data.fixture_id : data.event_id,
          provider_id: data.provider_id,
          sp: data.sp == "" ? null : data.sp,
          payment_percentage: data.payment_percentage == "" ? null : data.payment_percentage,
          confirmator: data.confirmator_id,
          user: data.username,
        };
        const response = await postData(
          settleOddEndPoint,
          { signal: "settlement", values: settlementOutcomesVar },
          {
            Authorization: getAuthorizationHeader(),
          }
        );
        // setUpdateEnabled(true);
        // setUpdateEnabled(false);
        // resetData();
        // setShowDialog(false);
      }
    });
  };

  const resendBetOddSettlement = async (e, data, index) => {
    e.preventDefault();

    Swal.fire({
      title: `Resend Settlement?`,
      html: `You are going to Resend Single Bet Odd Settlement. </br></br>Are you Sure?`,
      showDenyButton: true,
      showConfirmButton: true,
      confirmButtonText: "Yes",
      denyButtonText: "Cancel",
      icon: "warning",
      confirmButtonColor: "#87cb16",
      denyButtonColor: "#ff4a55",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const settleOddEndPoint = `/api/v1/bets/settlements/resend`;
        const operatorOutcomes = data.operatorOutcomes?.find((o) => o.betId == data.betIds[index]);
        const settlementOutcomesVar = {
          uuid: data.uuid,
          bet_id: operatorOutcomes ? operatorOutcomes.betId : data.betIds[index],
          outcome_id: operatorOutcomes ? operatorOutcomes.value : data.betOutcomes[index],
          event_id: data.fixture_id ? data.fixture_id : data.event_id,
          provider_id: data.provider_id,
          sp: data.sp == "" ? null : data.sp,
          payment_percentage: data.payment_percentage == "" ? null : data.payment_percentage,
          confirmator: data.confirmator_id,
          user: data.username,
        };
        const response = await postData(
          settleOddEndPoint,
          { signal: "settlement", values: settlementOutcomesVar },
          {
            Authorization: getAuthorizationHeader(),
          }
        );

        if (response != null) {
          setApiresponse("success");
          setApiResponseMsg("Bet odd Settlement resend to client.");
          setNotification(true);
          setShowDialog(false);
        } else {
          setApiresponse("error");
          setApiResponseMsg("Something went wrong while resend bet odd settlement.");
          setNotification(true);
          setShowDialog(false);
        }
      }
    });
  };

  const handleBlockFixture = async (e, fixture) => {
    e.preventDefault();

    let fixtures = [];

    if (fixture.providerId == 1000) {
      fixture.rowData.fixtureIds.map((f, i) => {
        fixtures.push({
          provider_id: fixture.rowData.providers[i],
          fixture_id: f,
          status: !fixture.blocked,
        });
      });
      fixtures.push({
        provider_id: fixture.providerId,
        fixture_id: fixture.fixture_id,
        status: !fixture.blocked,
      });
    } else {
      fixtures.push({
        provider_id: fixture.providerId,
        fixture_id: fixture.fixture_id,
        status: !fixture.blocked,
      });
    }
    Swal.fire({
      title: `You are going to ${fixture.blocked ? "UN" : ""}BAN ${
        fixtures.length > 1 ? "these Fixtures" : "this Fixture"
      } from Feed. \nAre you Sure?`,
      html: `<SoftBox pr={1} style={{ marginRight: "auto" }}>
                    ${fixtures.map(
                      (f) =>
                        `<SoftTypography key=${f.fixture_id} variant="caption">
                        ${f.fixture_id}
                      </SoftTypography>`
                    )}

                  </SoftBox>`,
      showDenyButton: true,
      showConfirmButton: true,
      confirmButtonText: `Yes, ${fixture.blocked ? "UN" : ""}BAN ${
        fixtures.length == 1 ? "it" : "them"
      }!`,
      denyButtonText: "Cancel",
      icon: "warning",
      confirmButtonColor: "success",
      // denyButtonColor: "#ff4a55",
    }).then(async (result) => {
      if (result.isConfirmed) {
        let setOddNoteEndPoint = `/api/v2/panel/filters/fixtures/blocked`;

        let response = await postData(setOddNoteEndPoint, fixtures, {
          Authorization: getAuthorizationHeader(),
        });

        if (response != null) {
          setApiresponse("success");
          setApiResponseMsg("Fixture Blocked succesfully!");
          blockedIds = await fetchBlockedFixtures();
          setNotification(true);
        } else {
          setApiresponse("error");
          setApiResponseMsg(
            "Something went wrong! Fixture doesn't Blocked. Please try again later. "
          );
          setNotification(true);
        }
      }
    });
  };

  useEffect(() => {
    fetchSettlementValues();
    if (pathname) {
      if (search) {
        let params = [...searchParams.entries()];
        let filters = {};
        for (let index = 0; index < params.length; index++) {
          const param = params[index];
          filters[param[0]] = param[1];
        }

        setPreloadFilters(filters);
        resetData();
        // setApplyFilters(true);
        // setFilterToggle(true);
        if (filters.uni_id) {
          if (filters.sport_id) {
            fetchBetsOdds(
              { fixture_uni_filter: filters.uni_id, sport_filter: [filters.sport_id] },
              false
            );
            return;
          }
          fetchBetsOdds({ fixture_uni_filter: filters.uni_id }, false);
        }
        if (filters.provider_id) {
          if (filters.sport_id) {
            fetchBetsOdds(
              {
                fixture_id_filter: filters.provider_id,
                sport_filter: [filters.sport_id],
              },
              false
            );
            return;
          }
          fetchBetsOdds({ fixture_id_filter: filters.provider_id }, false);
        }

        if (filters.odd_uuid) {
          fetchBetsOdds({ bet_odd_uuid: filters.odd_uuid }, false);
        }
        if (filters.bet_id) {
          fetchBetsOdds({ bet_id: filters.bet_id }, false);
        }
        if (filters.betbuilder_id) {
          fetchBetsOdds({ betbuilder_id: filters.betbuilder_id }, false);
        }
      }
    }
  }, []);

  useEffect(() => {
    if (providers) {
      //setAvailableProviders(providers);
      availableProviders = providers;
    }
  }, [providers]);

  return (
    <DashboardLayout>
      <DialogBox
        // @ts-ignore
        showDialog={showPrompt}
        confirmNavigation={confirmNavigation}
        cancelNavigation={cancelNavigation}
      />
      <DashboardNavbar />
      {renderTimeline()}
      {renderScoreboard()}
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        key={"topright"}
        open={notification}
        autoHideDuration={6000}
        onClose={handleClose}
      >
        <Alert
          onClose={handleClose}
          severity={`${apiResponse}`}
          sx={{ width: "100%" }}
          className={`api-${apiResponse}-notifications`}
        >
          {apiResponseMsg}
        </Alert>
      </Snackbar>
      <SoftBox my={3} sx={{ marginBottom: "0px" }}>
        <Grid container spacing={3}>
          <Grid item xs={12} lg={12} sx={{ marginLeft: "0px !important" }}>
            <AdvancedSettlementFilters
              applyFilters={applyFilters}
              settlementOutcomes={settlementOutcomes}
              forceToggle={filterToggle}
              informParent={handleBetsFilters}
              loadingData={loadingData}
              preLoadFilters={preloadFilters}
            ></AdvancedSettlementFilters>
            <SoftBox style={{ display: displayData ? "" : "none" }}>
              <Grid container spacing={0}>
                <Card style={{ width: "100%" }}>
                  <Grid item xs={12} sx={{ paddingTop: "0px", height: "100%" }}>
                    <SoftBox
                      display="flex"
                      justifyContent="space-between"
                      alignItems="flex-start"
                      pt={2}
                      pl={3}
                      pr={3}
                    >
                      <SoftBox lineHeight={1}>
                        <SoftTypography variant="h5" fontWeight="medium">
                          Bets
                        </SoftTypography>
                        <SoftTypography variant="button" fontWeight="regular" color="text">
                          Here you can find all <span style={{ color: "#cb0c9f" }}>bets</span> have
                          been placed in the Selected Platform
                        </SoftTypography>
                      </SoftBox>
                      <SoftBox lineHeight={1}>
                        <Button disabled={updateEnabled ? false : true} onClick={handleCancelEdit}>
                          Cancel
                        </Button>
                        <Button onClick={viewChanges} disabled={updateEnabled ? false : true}>
                          {modeChanges ? "view All" : "view Changes"}
                        </Button>
                        <Button onClick={handleUpdate} disabled={updateEnabled ? false : true}>
                          Update
                        </Button>
                        <Button onClick={handleExportData}>Export Data</Button>
                      </SoftBox>
                    </SoftBox>

                    <DataTable
                      table={dataTableData}
                      // bottomPadding={26}
                      tableClassName="advanced-settlement-table"
                      entriesPerPage={{
                        defaultValue: 10,
                        entries: [5, 10, 15, 20, 25],
                      }}
                      hiddenColumns={hiddenColumns}
                      headerClassName="sticky-header"
                      autoResetPageDefault={true}
                      autoResetGlobalFilter={true}
                      autoResetSortBy={true}
                      canSearch
                      searchValue={externalSearch}
                      openBackDrop={loading}
                      informParent={informParent}
                      refreshEnabled={false}
                    ></DataTable>
                  </Grid>
                </Card>
              </Grid>
            </SoftBox>
          </Grid>
        </Grid>
      </SoftBox>
    </DashboardLayout>
  );
}

export default AdvancedSettlement;
